var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('button',{staticClass:"naver_login_wrap",on:{"click":_vm.triggerNaver}},[_c('a',{staticStyle:{"display":"none"},attrs:{"id":"naverIdLogin"}}),_c('img',{attrs:{"src":require("@/assets/image/main/naver.png")}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }